import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext"
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from "lexical"
import { useEffect } from "react"

import { isModifierKey } from "@/helpers/utils"

function CmdEnterPlugin() {
  const [editor] = useLexicalComposerContext()

  useEffect(() => {
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        if (!!event && isModifierKey(event)) {
          event.preventDefault()

          return true
        }

        return false
      },
      COMMAND_PRIORITY_HIGH
    )
  }, [editor])

  return null
}

export default CmdEnterPlugin
